import { ReactNode } from 'react'

export type IconPositionType = 'left' | 'right' | undefined

export type VariantType =
  | 'solid-primary'
  | 'solid-warning'
  | 'solid-danger'
  | 'outline-primary'
  | 'outline-primary-nohover'
  | 'outline-warning'
  | 'outline-danger'
  | undefined

export type SizeType = 'xs' | 'sm' | 'md' | 'lg' | 'xl'

export interface IButtonProps {
  block?: boolean
  children?: ReactNode
  icon?: ReactNode
  iconPosition?: IconPositionType
  label?: string
  variant?: VariantType
  size?: SizeType
  disabled?: boolean
  loading?: boolean
  className?: string
  onClick?: () => void
  type?: 'button' | 'submit' | 'reset'
}

const ButtonLink = (props: IButtonProps) => {
  const {
    block,
    children,
    icon,
    iconPosition = 'left',
    label,
    variant,
    size = 'md',
    disabled = false,
    loading = false,
    className,
    onClick,
    type = 'button',
    ...restProps
  } = props
  
  return (
    <button
      className={`swui-button ${
        block && 'swui-button--block'
      } swui-button--${variant} swui-button--${size} ${className}`}
      disabled={disabled}
      type={type}
      {...(onClick && {onClick: onClick})}
      {...restProps}
    >
      <div className='flex items-center justify-center'>
      {loading && <div className="loader loader--sm" />}
      {!loading && icon && iconPosition === 'left' && icon}

      {loading && label ? (
        <span className="mx-2">Memuat...</span>
      ) : (
        <span className={icon ? 'mx-2' : ''}>{label}</span>
      )}

      {!loading && children}
      {!loading && icon && iconPosition === 'right' && icon}
      </div>
    </button>
  )
}

export default ButtonLink
